// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// TODO. Ugly. Refactor. Lots of duplicated pieces of code
// (sltp, boundTo parameters and whatnot).
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { StopLimitOrderEdit } from '../order-edit/StopLimitOrderEdit';
import { OrderEditUpdateData } from '@shared/utils/Trading/OrderEditUpdateData';
import { TIF } from '@shared/utils/Trading/OrderTif';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { OrderExecutorUtils } from '../../../Trading/OrderExecutorUtils';
import { BoundToEdit } from '../BoundToEdit';
import { IsAllowed } from '../../../IsAllowed';
export class ModifyStopLimitOrder extends StopLimitOrderEdit {
    constructor(data) {
        super(data);
        this.order = data.order;
        this.boundToEdit = new BoundToEdit();
        this.updateParameters(new OrderEditUpdateData(null, {
            instrument: this.order.Instrument,
            account: this.order.Account,
            side: this.order.BuySell,
            quantity: new Quantity(this.order.Amount, true),
            tif: new TIF(this.order.TimeInForce, new Date(this.order.ExpireAt)),
            leverageValue: this.order.Leverage,
            order: this.order,
            isAllowOTHTrading: this.order.IsAllowOTHTrading
        }));
        this.setSLTP({ sltpHolder: this.order.createSlTpHolder() });
    }
    getParameterNameArray() {
        const paramNameArr = super.getParameterNameArray();
        paramNameArr.push('boundTo');
        return paramNameArr;
    }
    dispose() {
        super.dispose();
        this.order = null;
    }
    // TODO. Refactor.
    setTradingData(tradingDataDict) {
        const newTradingDataDict = super.setTradingData(tradingDataDict);
        if (!newTradingDataDict) {
            return newTradingDataDict;
        }
        if ('order' in tradingDataDict) {
            this.order = tradingDataDict.order;
            newTradingDataDict.order = this.order;
        }
        return newTradingDataDict;
    }
    // TODO. Refactor base class, trading data. Ugly.
    getTradingData() {
        const tradingDataDict = super.getTradingData();
        tradingDataDict.order = this.order;
        return tradingDataDict;
    }
    // TODO. Refactor base class, trading data. Ugly.
    getDataForRequest() {
        const reqData = super.getDataForRequest();
        if (reqData) {
            reqData.order = this.order;
        }
        return reqData;
    }
    update_stopPrice(updateData) {
        let parameterChanged = super.update_stopPrice(updateData);
        const newTradingDataDict = updateData.newTradingDataDict;
        if (!newTradingDataDict) {
            return parameterChanged;
        }
        const order = newTradingDataDict.order;
        if (!order) {
            return parameterChanged;
        }
        const newStopPrice = order.StopLimit;
        if (newStopPrice !== this.stopPrice) {
            this.stopPrice = newStopPrice;
            parameterChanged = true || parameterChanged;
            parameterChanged = this.tryUpdateWarning_stopPrice(this.stopPrice, this.quote) || parameterChanged;
        }
        return parameterChanged;
    }
    update_limitPrice(updateData) {
        let parameterChanged = super.update_limitPrice(updateData);
        const newTradingDataDict = updateData.newTradingDataDict;
        if (!newTradingDataDict) {
            return parameterChanged;
        }
        const order = newTradingDataDict.order;
        if (!order) {
            return parameterChanged;
        }
        const newLimitPrice = order.Price;
        if (newLimitPrice !== this.limitPrice) {
            this.limitPrice = newLimitPrice;
            parameterChanged = true || parameterChanged;
        }
        return parameterChanged;
    }
    update_boundTo(updateData) {
        return this.boundToEdit.update(updateData);
    }
    toDynProperty_boundTo() {
        return this.boundToEdit.getDynProperty();
    }
    toRawValue_boundTo() {
        return this.boundToEdit.getRawValue();
    }
    getLeverageValue() {
        return this.order ? this.order.Leverage : null;
    }
    // TODO. Ugly. Duplication.
    getConfirmationText() {
        const _super = Object.create(null, {
            getConfirmationText: { get: () => super.getConfirmationText }
        });
        return __awaiter(this, arguments, void 0, function* (sendMarginRequest = true) {
            const confirmationText = yield _super.getConfirmationText.call(this, sendMarginRequest);
            return OrderExecutorUtils.getModifyOrderEditConfirmation(this.order, confirmationText);
        });
    }
    tradingAllowed() {
        return IsAllowed.IsOrderModifyingAllowed(this.order).Allowed;
    }
}
